import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { QuoteLinesEntityEffects } from './quote-lines.effects';

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([QuoteLinesEntityEffects])]
})
export class QuoteLinesEntityModule {}
